// extracted by css-extract-rspack-plugin
export default {"cardContainer":"cardContainer-GOOgS7"};